import { toOptions } from './ArrayUtil';
export const weekData = ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'];
export const weekOptionsShort = toOptions(['日', '月', '火', '水', '木', '金', '土']);
export const weekOptions = toOptions(weekData);
